import {
  Box,
  Button,
  Flex,
  FormLabel,
  Heading,
  HStack,
  Input,
  Stack,
  Switch,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ReactQuill from "react-quill";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { closeCreateQuestionModel } from "../../../../modules/admin-modules/models/Actions";

import "react-quill/dist/quill.snow.css";
import { getAllBucketsRequest } from "../../../../modules/superadmin-modules/bucket/Actions";
import {
  createQuestionBankRequest,
  editQuestionBankRequest,
} from "../../../../modules/superadmin-modules/questions-bank/Actions";
import { getAllTagsRequest } from "../../../../modules/superadmin-modules/tags/Actions";

const AddQuestion = ({ isAdd, data, setSelectedData }) => {
  const baseUrl = "https://api.agwad.net/";

  const dispatch = useDispatch();

  const [selected, setSelected] = useState("");
  const [questionAnswerImg, setQuestionAnswerImg] = useState("");

  const [answers, setAnswers] = useState([]);
  const [rightAnswer, setRightAnwser] = useState();
  const [isFiveChoices, setIsFiveChoices] = useState(false);
  const openQuestions = useSelector((state) => state.model.isOpen16);

  const buckets = useSelector((state) => state.superadminBuckets.buckets);
  const tags = useSelector((state) => state.superadminTags.tags);

  const isLoading = useSelector((state) => state.questionsBank.isLoading);
  useEffect(() => {
    if (openQuestions) {
      dispatch(getAllTagsRequest());
      dispatch(getAllBucketsRequest());
    }
  }, [openQuestions]);

  useEffect(() => {
    if (!isAdd) {
      setAnswers(data?.answers);
      const filter = data?.answers
        ?.map((data, index) => {
          if (data?.right_answer == 1) return index;
        })
        .filter((data) => data != undefined);
      if (filter?.length > 0) {
        setRightAnwser(filter[0]);
      }
    } else if (isAdd) {
      setAnswers([]);
      setRightAnwser(null);
    }
  }, [isAdd, data]);
  const bucketsOptions = buckets?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const tagsOptions = tags?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: !isAdd ? data : { difficulty_level: 0, mark: 1 },
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة سؤال" : "تعديل  سؤال"}
      </Heading>
    </Box>
  );

  const onSubmit = async (val) => {
    let formData = new FormData();

    const values = {
      ...val,
      difficulty_level: val?.difficulty_level ? val?.difficulty_level : "0",
    };
    const keys = [
      "select",
      "answers",
      "index",
      "delete",
      "edit",
      "chapter",
      "bookmark",
      "Actions",
      "deleted_at",
      "tags",
      "defcultyLevels",
      "questionTable",
      "bucket",
      "course",
    ];
    const action = () => {
      dispatch(closeCreateQuestionModel());
      setSelectedData({});
      reset();
      setAnswers([]);
    };
    answers.map((data, idx) =>
      formData.append(`answers[${idx}][answer]`, data?.answer)
    );
    answers.map((data, idx) =>
      formData.append(
        `answers[${idx}][right_answer]`,
        data?.right_answer ? data?.right_answer : 0
      )
    );
    values?.tags?.map((data, idx) =>
      formData.append(`tags[${idx}]`, data?.value)
    );
    if (isAdd) {
      for (let key in values) {
        if (!keys.includes(key) && values[key] != null)
          formData.append(key, values[key]);
      }

      const filteredAnswers = answers?.filter(
        (data, idx) => data?.right_answer == 1
      );

      const expectedAnswersLength = isFiveChoices ? 5 : 4;
      if (values.bucket_id && answers?.length == expectedAnswersLength) {
        if (filteredAnswers?.length > 0)
          await dispatch(createQuestionBankRequest(formData, action));
        else toast.error("اختر اجابة صحيحة ");
      } else {
        toast.error("  قم بمراجعة الاجابات او  اختر الفصل ");
      }
    } else {
      formData.append("_method", "PUT");

      const totel = { ...data, ...values };
      answers.map((data, idx) =>
        formData.append(`answers[${idx}][id]`, data?.id)
      );

      for (let key in totel) {
        if (!keys.includes(key) && totel[key] != null) {
          formData.append(key, totel[key]);
        }
      }
      dispatch(
        editQuestionBankRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };
  const closeFunc = () => {
    dispatch(closeCreateQuestionModel());
    setSelectedData({});
    setAnswers([]);
    reset();
  };

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openQuestions}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex w="100%" flexWrap="wrap" justifyContent="space-between" gap="6">
          <Box w="100%" dir="rtl">
            <FormLabel>نص القطعة:</FormLabel>
            <Textarea
              name="comprehension"
              placeholder="ادخل نص القطعة التي تسبق السؤال"
              defaultValue={data?.comprehension}
              error={errors?.comprehension?.message}
              {...register("comprehension")}
            />
          </Box>
          <Box w="100%">
            <Text dir="rtl"> نص السؤال </Text>
            <ReactQuill
              theme="snow"
              register={register}
              name="question"
              defaultValue={data?.question}
              onChange={(val) => setValue("question", val)}
            />
          </Box>

          <HStack w="100%" my="20px" justifyContent="space-between" dir="rtl">
            <HStack w="50%">
              <FormLabel>صورة السؤال:</FormLabel>
              <Button
                bg="main_1"
                color="white"
                borderRadius="8px"
                textAlign="center"
                position="relative"
              >
                <Text>
                  {selected
                    ? selected
                    : data?.question_image
                    ? `file_1`
                    : "اختر ملف ليتم رفعه"}
                </Text>
                <Input
                  onChange={(e) => {
                    setValue("question_image", e.target.files[0]);
                    setSelected((s) => e.target.files[0].name);
                  }}
                  type="file"
                  placeholder="اختر ملف ليتم رفعه"
                  opacity="0"
                  position="absolute"
                  w="100%"
                  h="100%"
                />
              </Button>
            </HStack>
            {data?.question_image && (
              // eslint-disable-next-line jsx-a11y/alt-text
              <img src={`${baseUrl}/${data?.question_image}`} width="200px" />
            )}
          </HStack>

          <HStack w="100%" my="20px" justifyContent="space-between" dir="rtl">
            <HStack w="50%">
              <FormLabel>صورة اجابة السؤال:</FormLabel>
              <Button
                bg="main_1"
                color="white"
                borderRadius="8px"
                textAlign="center"
                position="relative"
              >
                <Text>
                  {questionAnswerImg
                    ? questionAnswerImg
                    : data?.model_answer_image
                    ? `file_1`
                    : "اختر ملف ليتم رفعه"}
                </Text>
                <Input
                  onChange={(e) => {
                    setValue("model_answer_image", e.target.files[0]);
                    setQuestionAnswerImg((s) => e.target.files[0].name);
                  }}
                  type="file"
                  placeholder="اختر ملف ليتم رفعه"
                  opacity="0"
                  position="absolute"
                  w="100%"
                  h="100%"
                />
              </Button>
            </HStack>
            {data?.model_answer_image && (
              <img
                src={`${baseUrl}/${data?.model_answer_image}`}
                width="200px"
                alt=""
              />
            )}
          </HStack>

          <HStack
            w="100%"
            my="20px"
            justifyContent="space-between"
            dir="rtl"
            gap={4}
          >
            <Box w="50%" dir="rtl">
              {" "}
              <MainInput
                label="رابط الاجابة"
                defaultValues={data?.answer_url}
                error={errors?.answer_url?.message}
                placeholder="ادخل رابط الاجابة"
                register={register}
                name="answer_url"
                required={false}
              />
            </Box>

            <Box w="50%" dir="rtl">
              <MainInput
                label="درجة السؤال"
                defaultValues={data?.mark || 1}
                error={errors?.mark?.message}
                placeholder="ادخل درجة السؤال"
                register={register}
                name="mark"
                type="number"
                required={false}
              />
            </Box>
          </HStack>

          <HStack
            w="100%"
            my="20px"
            justifyContent="space-between"
            dir="rtl"
            gap={4}
          >
            <Box w="50%">
              <FormLabel>مجموعة الاسئلة : </FormLabel>
              <Select
                options={bucketsOptions}
                onChange={(data) => setValue("bucket_id", data.value)}
                styles={colourStyles}
                placeholder="الصف"
                defaultValue={{
                  label: data?.bucket?.name,
                  value: data?.bucket?.id,
                }}
              />
            </Box>
            <Box w="50%">
              <FormLabel> علامات الاسئلة : </FormLabel>
              <Select
                options={tagsOptions}
                isMulti
                onChange={(data) => setValue("tags", data)}
                styles={colourStyles}
                placeholder="الصف"
                defaultValue={data?.tags?.map((val) => ({
                  label: val?.name,
                  value: val?.id,
                }))}
              />
            </Box>
          </HStack>

          <Box w="100%" dir="rtl">
            <FormLabel> مستوي السؤال : </FormLabel>

            <Stack
              direction="row"
              role="group"
              aria-labelledby="my-radio-group"
              spacing="20px"
              defaultChecked={0}
            >
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="1"
                  defaultChecked={data?.difficulty_level == 1 ? true : false}
                />
                notes
              </label>
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="2"
                  defaultChecked={data?.difficulty_level == 2 ? true : false}
                />
                كتاب المدرسة
              </label>
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="3"
                  defaultChecked={data?.difficulty_level == 3 ? true : false}
                />
                hard questions
              </label>
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="4"
                  defaultChecked={data?.difficulty_level == 4 ? true : false}
                />
                امتحانات السنين السابقة
              </label>
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="5"
                  defaultChecked={data?.difficulty_level == 5 ? true : false}
                />
                Revision
              </label>
            </Stack>
          </Box>
          <Box w="100%" dir="rtl">
            <HStack mb="10px">
              <FormLabel>الاجابات : </FormLabel>
              <HStack>
                <input
                  type="checkbox"
                  id="fiveChoices"
                  checked={isFiveChoices}
                  onChange={(e) => setIsFiveChoices(e.target.checked)}
                />
                <label htmlFor="fiveChoices">5 خيارات</label>
              </HStack>
            </HStack>
            {[...Array(isFiveChoices ? 5 : 4)].map((val, index) => {
              return (
                <HStack my="10px">
                  <Input
                    defaultValue={
                      data?.answers?.length > 0 && !isAdd
                        ? data?.answers[index]?.answer
                        : null
                    }
                    placeholder="اضف الإجابة  "
                    size="md"
                    onChange={(e) => {
                      const newAnswers = answers;
                      newAnswers[index] = {
                        ...newAnswers[index],
                        answer: e.target.value,
                      };
                      setAnswers(newAnswers);
                    }}
                  />

                  <Switch
                    size="lg"
                    // isChecked={defaultChecked(index)}
                    isChecked={rightAnswer == index ? true : false}
                    color="#010038"
                    onChange={(e) => {
                      setRightAnwser(index);
                      let newAnswers = answers;
                      let mappedData = newAnswers?.map((val, idx) => {
                        return { ...val, right_answer: idx == index ? 1 : 0 };
                      });
                      setAnswers(mappedData);
                    }}
                  />

                  {/* {!isAdd && (
                    <Button
                      onClick={() =>
                        handelEditQuestion(data?.answers[index]?.id, index)
                      }
                    >
                      Edit
                    </Button>
                  )} */}
                </HStack>
              );
            })}
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddQuestion;
